// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const electabuzz: PokeData = {
  "id": 125,
  "name": "electabuzz",
  "height": 11,
  "weight": 300,
  "base_experience": 172,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "leer",
    "low-kick",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "screech",
    "light-screen",
    "swift",
    "spark",
    "charge",
    "shock-wave",
    "giga-impact",
    "discharge",
    "electro-ball"
  ],
  "moves": [
    "thunder-punch",
    "leer",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "thunder-fang",
    "wild-charge",
    "volt-switch",
    "electric-terrain",
    "zap-cannon",
    "quick-tempo",
    "electric-wrath"
  ],
  "evolution_chain": {
    "id": 60,
    "item": null,
    "species": [
      {
        "name": "elekid",
        "order": 145,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "electabuzz",
        "order": 146,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 239,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "electivire",
        "order": 147,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 125,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68,
    "speed": 105,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
